import React from 'react';
import prylpoolenPlaceholder from '../../styles/images/prylpoolen-image.png';
import { Translate } from "react-redux-i18n";
import TranslatedPage from "../../containers/TranslatedPage";

export default function Prylpoolen() {
    return (
        <section className="gray-bg">
            <div className="main-container">
                <div className="content-wrapper">
                    <div className="landing-box-feature prylpoolen">
                        <div className="landing-box-copy">
                            <h4><TranslatedPage path="home.content_blocks.landing_prylpool.subheading" /></h4>
                            <h1><TranslatedPage path="home.content_blocks.landing_prylpool.heading" /></h1>
                            <div className="mobile-landing-box-illustration">
                                <img src={prylpoolenPlaceholder} alt="ihopa Prylpoolen"/>
                            </div>
                            <div className="landing-box-content">
                                <TranslatedPage path="home.content_blocks.landing_prylpool.content" />
                            </div>
                            <a href="https://blog.ihopa.com/prylpool/" className="bp3-button bp3-intent-primary cta secondary-color" target="_blank" rel="noopener noreferrer"><strong><Translate value="home.prylpoolen.button_text"/></strong></a>
                        </div>
                        <div className="landing-box-illustration">
                            <img src={prylpoolenPlaceholder} alt="ihopa Prylpoolen"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}